import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { AuthService, CommonService, NotificationService } from '../../service';
import { environment } from '../../../../environments/environment';
import { Permission } from '../../enum';
import { TypeLookupItem } from '../../model';
import { tooltip } from '../../enum/tooltip.enum';
import { has } from 'underscore';
import { NgIf } from '@angular/common';
import { MenubarModule } from 'primeng/menubar';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [NgIf, MenubarModule]
})

export class NavBarComponent {
  toolTip: TypeLookupItem[];
  version = environment.uivn;
  menu: MenuItem[] = null;
  isNotificationMenu = false;

  constructor(@Inject(AuthService) public authService: AuthService) {
  }

  visible() {
    if (window.location.href.indexOf('termsandconditions') === -1 && this.authService.isAuthenticated()) {
      let podMaintenanceLandingPage = '';
      if (this.authService.hasPermission([Permission.Pods_Maintain, Permission.Pods_Maintain_Overview])) {
        podMaintenanceLandingPage = '/pod/maintenance/overview';
      } else if (this.authService.hasPermission([Permission.Pods_Maintain, Permission.Pods_Maintain_SIM])) {
        podMaintenanceLandingPage = '/pod/maintenance/sim';
      } else if (this.authService.hasPermission([Permission.Pods_Maintain, Permission.Pods_Maintain_API])) {
        podMaintenanceLandingPage = '/pod/maintenance/api';
      } else if (this.authService.hasPermission([Permission.Pods_Maintain, Permission.Pods_Maintain_Data])) {
        podMaintenanceLandingPage = '/pod/maintenance/data';
      } else if (this.authService.hasPermission([Permission.Pods_Maintain, Permission.Pods_Maintain_GPS])) {
        podMaintenanceLandingPage = '/pod/maintenance/gps';
      } else if (this.authService.hasPermission([Permission.Pods_Maintain, Permission.Pods_Maintain_Hardware])) {
        podMaintenanceLandingPage = '/pod/maintenance/hardware';
      } else if (this.authService.hasPermission([Permission.Pods_Maintain, Permission.Pods_Maintain_Settings])) {
        podMaintenanceLandingPage = '/pod/maintenance/settings';
      } else if (this.authService.hasPermission([Permission.Pods_Maintain, Permission.Pods_Maintain_Sensors])) {
        podMaintenanceLandingPage = '/pod/maintenance/sensors';
      } else if (this.authService.hasPermission([Permission.Pods_Maintain, Permission.Pods_Maintain_Calibration])) {
        podMaintenanceLandingPage = '/pod/maintenance/calibration';
      } else if (this.authService.hasPermission([Permission.Pods_Maintain, Permission.Pods_Maintain_Diagnostics])) {
        podMaintenanceLandingPage = '/pod/maintenance/diagnostics';
      } else if (this.authService.hasPermission([Permission.Pods_Maintain, Permission.Pods_Maintain_Readings])) {
        podMaintenanceLandingPage = '/pod/maintenance/readings';
      }

      if (this.menu === null) {
        this.menu = [
          {
            label: 'Home', icon: 'fas fa-home', routerLink: '/dashboard', routerLinkActiveOptions: '{exact: true}', visible: this.authService.hasPermission(Permission.Pod_Connection_Dashboard) && this.authService.getUser().reset_password === false,
            items: [
              { label: 'Shop Window', url: 'https://public.aqmeshdata.net/#/dashboard', target: '_blank', routerLinkActiveOptions: '{exact: true}' },
            ]
          },
          {
            icon: 'fas fa-edit',
            label: 'Admin',
            visible: this.authService.hasPermission([Permission.Admin_Distributors, Permission.Admin_Owners, Permission.Admin_Projects, Permission.Admin_Pod_Location, Permission.Admin_Users, Permission.Admin_Roles, Permission.Admin_Permissions]) && this.authService.getUser().reset_password === false,
            items: [
              { label: 'Distributors', routerLink: '/maintenance/distributors', routerLinkActiveOptions: '{exact: true}', visible: this.authService.hasPermission(Permission.Admin_Distributors) },
              { label: 'Owners', routerLink: '/maintenance/owners', routerLinkActiveOptions: '{exact: true}', visible: this.authService.hasPermission(Permission.Admin_Owners) },
              { label: 'Projects', routerLink: '/maintenance/projects', routerLinkActiveOptions: '{exact: true}', visible: this.authService.hasPermission(Permission.Admin_Projects) },
              { label: 'Users', routerLink: '/maintenance/users', routerLinkActiveOptions: '{exact: true}', visible: this.authService.hasPermission(Permission.Admin_Users) },
              { label: 'Roles', routerLink: '/maintenance/roles', routerLinkActiveOptions: '{exact: true}', visible: this.authService.hasPermission(Permission.Admin_Roles) },
              { label: 'Permissions', routerLink: '/maintenance/permissions', routerLinkActiveOptions: '{exact: true}', visible: this.authService.hasPermission(Permission.Admin_Permissions) },
              { label: 'Sales Order QC', routerLink: '/maintenance/salesorderqc', routerLinkActiveOptions: '{exact: true}', visible: this.authService.isAdministrator() },
              { label: 'Returns Board', routerLink: '/maintenance/returnsboard', routerLinkActiveOptions: '{exact: true}', visible: this.authService.isAdministrator() }
            ]
          },
          {
            icon: 'fas fa-project-diagram',
            label: 'Pods',
            visible: this.authService.hasPermission([Permission.Pods_Order, Permission.Pods_Build, Permission.Pods_Contract, Permission.Pods_Maintain, Permission.Pods_Maintain_Overview, Permission.Pods_Maintain_SIM, Permission.Pods_Maintain_API, Permission.Pods_Maintain_Data, Permission.Pods_Maintain_GPS, Permission.Pods_Maintain_Hardware, Permission.Pods_Maintain_Settings, Permission.Pods_Maintain_Sensors, Permission.Pods_Maintain_Calibration, Permission.Pods_Maintain_Diagnostics, Permission.Pods_Maintain_Readings, Permission.Pods_Maintain_Map, Permission.Pods_Data]) && this.authService.getUser().reset_password === false,
            items: [
              { label: 'Order', routerLink: '/pod/order', routerLinkActiveOptions: '{exact: true}', visible: this.authService.hasPermission(Permission.Pods_Order) },
              { label: 'Build', routerLink: '/pod/build/create', routerLinkActiveOptions: '{exact: true}', visible: this.authService.hasPermission(Permission.Pods_Build) },
              { label: 'Contract', routerLink: '/pod/contract', routerLinkActiveOptions: '{exact: true}', visible: this.authService.hasPermission(Permission.Pods_Contract) },
              { label: 'Maintain', routerLink: podMaintenanceLandingPage, routerLinkActiveOptions: '{exact: true}', visible: this.authService.hasPermission([Permission.Pods_Maintain, Permission.Pods_Maintain_Overview, Permission.Pods_Maintain_SIM, Permission.Pods_Maintain_API, Permission.Pods_Maintain_Data, Permission.Pods_Maintain_GPS, Permission.Pods_Maintain_Hardware, Permission.Pods_Maintain_Settings, Permission.Pods_Maintain_Sensors, Permission.Pods_Maintain_Calibration, Permission.Pods_Maintain_Diagnostics, Permission.Pods_Maintain_Readings, Permission.Pods_Maintain_Map]) },
              { label: 'View Data', routerLink: '/pod/chart', routerLinkActiveOptions: '{exact: true}', visible: this.authService.hasPermission(Permission.Pods_Data) },
              {
                label: 'Pullsheet',
                visible: this.authService.hasPermission(Permission.Engineer_Pullsheet),
                items: [
                  {
                    label: 'Pullsheet',
                    routerLink: '/engineer/pullsheet', routerLinkActiveOptions: '{exact: true}', visible: this.authService.hasPermission(Permission.Engineer_Pullsheet),
                  },
                  {
                    label: 'Pullsheet Batch',
                    routerLink: '/engineer/batch', routerLinkActiveOptions: '{exact: true}', visible: this.authService.hasPermission(Permission.Engineer_Pullsheet),
                  },
                ]
              },
              { label: 'Alert Maintenance', routerLink: '/alerts', routerLinkActiveOptions: '{exact: true}', visible: this.authService.hasPermission(Permission.Sensors_Alert_Trigger) },
            ]
          },
          {
            icon: 'fas fa-toolbox',
            label: 'Quality Control Criteria',
            visible: this.authService.hasPermission(Permission.Pods_Maintain_QA_QC_Full_Control),
            routerLink: '/toolkit/criteria'
          },
          {
            icon: 'fas fa-microchip',
            label: 'Sensors',
            visible: this.authService.hasPermission([Permission.Sensors_Data, Permission.Sensors_Failure, Permission.Sensors_Allocation, Permission.Sensors_Alert_Trigger]) && this.authService.getUser().reset_password === false,
            items: [
              { label: 'Sensor Data', routerLink: '/workflow/characterisation', routerLinkActiveOptions: '{exact: true}', visible: this.authService.hasPermission(Permission.Sensors_Data) },
              { label: 'Sensor Management', routerLink: '/workflow/fails', routerLinkActiveOptions: '{exact: true}', visible: this.authService.hasPermission(Permission.Sensors_Failure) },
              { label: 'Sensor Allocation', routerLink: '/workflow/sensorallocation', routerLinkActiveOptions: '{exact: true}', visible: this.authService.hasPermission(Permission.Sensors_Allocation) },
              {
                label: 'Characterisation',
                visible: this.authService.isAdministrator(),
                items: [
                  { label: 'Setup', routerLink: '/workflow/characterisation/setup', routerLinkActiveOptions: '{exact: true}', visible: this.authService.isAdministrator() },
                  { label: 'Criteria', routerLink: '/workflow/characterisation/criteria', routerLinkActiveOptions: '{exact: true}', visible: this.authService.isAdministrator() },
                  { label: 'Audit', routerLink: '/workflow/characterisation/audit', routerLinkActiveOptions: '{exact: true}', visible: this.authService.isAdministrator() },
                ]
              }
            ]
          },
          {
            label: 'API', icon: 'fas fa-book', url: 'https://www.aqmesh.com/resources/aqmesh-api-instructions/', target: '_blank', routerLinkActiveOptions: '{exact: true}', visible: (this.authService.hasPermission(Permission.Access_API) && this.authService.getUser().reset_password === false),
          },
          {
            label: 'Technician', icon: 'fas fa-heartbeat', routerLink: '/maintenance/technician', routerLinkActiveOptions: '{exact: true}', visible: (this.authService.getUser().reset_password === false && (this.authService.hasPermission(Permission.Technician_Lite) || this.authService.hasPermission(Permission.Technician_Plus))),
          },
          {
            label: this.authService.getUser().user_name, icon: 'far fa-user', routerLink: '/profile', routerLinkActiveOptions: '{exact: true}',
          },
          {
            label: 'Logout', icon: 'fas fa-sign-out-alt', command: (event) => { this.logout(); }
          }
        ];

        const shopWindowPermission = this.authService.hasPermission(Permission.Shopwindow);

        if (!shopWindowPermission) {
          this.menu[0].items = [];
        }

      }
      return true;
    } else {
      this.menu = null;
    }
    return false;
  }

  public clearNav() {
    this.menu = null;
    this.visible();
  }

  logout() {
    this.authService.logout();
  }

}
